import { useUserStore } from '../../stores/userStore';
// Writes may complete after navigation, but never on behalf of a replacement session.
export function notificationRequest() {
  const state = useUserStore.getState(),
    id = state.user?.id,
    token = localStorage.getItem('POSTPOP_AUTH_TOKEN'),
    controller = new AbortController();
  let valid = true;
  const off = useUserStore.subscribe((a, b) => {
    if (a.user?.id !== b.user?.id || a.isLogin !== b.isLogin || a.isAdmin !== b.isAdmin) {
      valid = false;
      controller.abort();
    }
  });
  const current = () =>
    valid &&
    !controller.signal.aborted &&
    useUserStore.getState().user?.id === id &&
    localStorage.getItem('POSTPOP_AUTH_TOKEN') === token;
  return {
    current,
    cancel: () => controller.abort(),
    finish: off,
    options: { signal: controller.signal, suppressGlobalError: true, isSessionCurrent: current },
  };
}
